import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useWorkspace } from "@/context/workspace";

export function RequireWorkspace({ children }: { children: React.ReactNode }) {
  const { initialized, loading, memberships, error, refresh } = useWorkspace();
  const loc = useLocation();

  if (!initialized || loading) {
    return <div className="p-4 text-sm text-muted-foreground">Checking workspace…</div>;
  }

  if (error) {
    return (
      <div className="p-4 text-sm">
        <div className="text-destructive mb-2">Failed to load workspace: {error}</div>
        <div className="flex gap-3">
          <button className="underline" onClick={() => refresh()}>Try again</button>
          <a className="underline" href="/workspace/new">Create workspace…</a>
        </div>
      </div>
    );
  }

  if (!memberships.length) {
    const redirect = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/workspace/new?redirect=${redirect}`} replace />;
  }

  return <>{children}</>;
}

export default RequireWorkspace;
